<template>
  <div class="ask-messages-list">
    <LoaderWithText v-if="chatStore.fetching && conversation.messages?.length === 0" />

    <template v-else>
      <div
        ref="loadMoreAnchor"
        class="ask-load-more"
      >
        <Button
          v-if="conversation.messages.has_more"
          variant="primary"
          size="3_5"
          :loading="chatStore.fetching"
          @click="handleLoadMore"
        >
          Load More
        </Button>
      </div>

      <AskMessage
        v-for="(message, i) in conversation.messages"
        :key="i"
        :ref="el => messageRefs[i] = el"
        :message="message"
      />

      <AskMessage
        v-if="conversation.streamingMessage?.text"
        :message="conversation.streamingMessage"
        format="markdown"
      />
    </template>
  </div>
</template>

<script setup>
import { computed, defineEmits, ref } from 'vue';
import { useChatStore } from '@frontend/ui/stores/chatStore';
import { Button, LoaderWithText } from '@stakeui';

import AskMessage from './AskMessage.vue';

const chatStore = useChatStore();
const emit = defineEmits(['load-more']);

const loadMoreAnchor = ref(null);
const messageRefs = ref([]);

const conversation = computed(() => chatStore.conversations[chatStore.currentConversationId] ?? { messages: [], streamingMessage: { text: '' } });

const handleLoadMore = () => {
  emit('load-more', conversation.value, loadMoreAnchor.value.offsetTop, loadMoreAnchor.value.offsetHeight);
};
</script>

<style scoped>
.ask-load-more {
  display: flex;
  align-items: center;
  justify-content: center;
}

.ask-messages-list {
  display: flex;
  flex-direction: column;
  gap: 1em;
}
</style>
